module.exports = __webpack_public_path__ + "img/folio-mobile.d63fe9c.jpg";